export default __webpack_public_path__ + "static/pancreas-top-73fd40d513960a6bedb6b688fc229af1.png";